export default "__VITE_ASSET__GxGmqVXc__"